export default __webpack_public_path__ + "static/media/Mail sent-amico.35384874.svg";